/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import validator from 'validator';
import { find, includes } from 'lodash';

export const isVisible = (question, questionsMap, optionsMap) => {
  if (question.conditions.length === 0) return true;

  let show = false;

  question.conditions.forEach(condition => {
    const dependentQuestion = questionsMap[condition.shown_by_question_id];
    if (dependentQuestion == null) {
      return;
    }
    const dependentOption = optionsMap[condition.shown_by_option_id];
    if (dependentOption == null) {
      return;
    }

    show = show || (dependentOption.picked && isVisible(dependentQuestion, questionsMap, optionsMap));
  });

  return show;
};

const VALIDATIONS = {
  email: validator.isEmail,
  url: validator.isURL,
};

/* eslint-disable complexity */
export const validate = question => {
  if (question.type === 'additional_text') {
    return true;
  }

  let valid = true;

  if (question.required) {
    valid = valid && isAnswered(question);
  }

  if (VALIDATIONS[question.type] && question.text) {
    valid = valid && VALIDATIONS[question.type](question.text || '');
  }

  return valid;
};
/* eslint-enable complexity */

export const isAnswered = question => {
  if (isCheckboxOrRadio(question)) {
    return Boolean(find(question.options, 'picked'));
  } else {
    return Boolean(question.text);
  }
};

export const isCheckboxOrRadio = question => includes(['radio', 'checkbox', 'checkboxes'], question.type);
